<div class="container my-3">
    <p>{{ "survey.new.final.text" | translate }}</p>
        
    <button class="btn btn-primary mt-3 next-step" [disabled]="completed" (click)="onSubmit()">
        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
        {{ 'survey.new.final.button' | translate }}
    </button>
</div>
